export class ProductCard {
    id: number;
    name: string;
    logo: string;
    discount: string;
    varieties;
    currency;
    cashback;
    store_product_logo: string;
    store_product_name: string;
    show_countries: any;
    categories: any;
      
    constructor(product, storeDetail) {
      this.id = product.id;
      this.name = product.store_product_detail?.name || product.name;
      this.logo = product.store_product_detail?.logo || product.logo;
      this.store_product_logo = product.store_product_detail?.logo;
      this.store_product_name = product.store_product_detail?.name;
      this.currency = product.currency_detail;
      this.discount = product.store_product_detail?.discount;
      this.varieties = product.store_product_detail?.store_varieties;
      this.cashback = storeDetail?.has_cashback
        ? product.store_product_detail?.cashback
        : 0;
      this.show_countries = product.show_countries;
      this.categories = product.categories;
    }
  }
  